// extracted by mini-css-extract-plugin
export default {"page-wrapper":"HomePage_page-wrapper__XAnfA","main":"HomePage_main__1UuEL"};